import WindowAlert from "../Window/WindowAlert"
import styles from "./CatAlert.module.css"
import { translations } from "../../translations"
import { useTranslationUpdate } from "../../hooks/useTranslationUpdate"

export default function CatAlert({ onClose }: { onClose: () => void }) {
  useTranslationUpdate()
  
  return (
    <WindowAlert title={translations('cat_alert.title')} onClose={onClose} width={560} height={390} bodyClassName={styles.body}>
      <div className={styles.inner}>
        <div className={styles.lines}>
          <div className={styles.jp}>{translations('cat_alert.congratulations')}</div>
          <div className={styles.en}>{translations('cat_alert.message')}</div>
        </div>

        <img src="/images/cat-pixel.gif" className={styles.cat} alt="cat" />

        <button className={styles.ok} onClick={onClose}>{translations('cat_alert.ok')}</button>
      </div>
    </WindowAlert>
  )
}
